export default __webpack_public_path__ + "static/media/IMG_5232.60667296.JPG";